import { enums, NotificationType, type types } from "@fraction/shared";

/**
 * Pending decline is internal: the BDM reaches out before we decline, so
 * brokers and borrowers must not see a file move into (or out of) it.
 */
export function isHiddenFromNonEmployees(notification: types.WsNotification): boolean {
  if (notification.type !== NotificationType.APPLICATION_STATUS_CHANGE) {
    return false;
  }
  return (
    notification.toStatus === enums.ApplicationStatus.PENDING_DECLINE ||
    notification.fromStatus === enums.ApplicationStatus.PENDING_DECLINE
  );
}
